import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fontsource/inter/400.css";
import "@fontsource/playfair-display/700.css";
import "./styles/global.css";
import "./styles/theme.css";
import "./styles/animations.css";
import "./styles/home.css";
import "./styles/premium.css";
import "./styles/dashboard.css";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </BrowserRouter>
);
